import React from "react"
import { StaticImage } from "gatsby-plugin-image"

const ImageMO26 = () => {

  return (
    <StaticImage
      src="../../images/JPG-FEMALE-LOOK002-6.jpg"
      
      alt="Reserved avatar"
    />
  )
}

export default ImageMO26
